// extracted by mini-css-extract-plugin
export default {"paragraph":"TestimonialName_paragraph__DWIZI"};